//import samplePage from './sample-page';
//import pages from './pages';
import other from './other';
import global from './global';
import { NavItemType } from 'types';


// ==============================|| MENU ITEMS ||============================== //

export default function baseMenuItems(): { items: NavItemType[] } {


  // Example: keep your existing groups, but insert project-specific nav when a project is active
  //const base = [samplePage, pages, other];
  const base = [other];

  return {
    items: [global, ...base]
  };
}




/*
import samplePage from './sample-page';
import pages from './pages';
import other from './other';
import { NavItemType } from 'types';

// ==============================|| MENU ITEMS ||============================== //

const menuItems: { items: NavItemType[] } = {
  items: [ samplePage, pages, other]
};

export default menuItems;
*/